import React from 'react'

const Input = ({columnSpan, name, title, onChange, value, readonly, textColor, customClass, disable,rightText}) => {

  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  const textClass = textColor === 'gray' ? 'text-gray-200' : 'text-red-900';
  const readonlyClass = readonly || disable ? 'bg-gray-200 cursor-not-allowed' : 'bg-transparent';

  return (
    <div className={`w-full col-span-${columnSpan}`}>
      <div className='flex justify-between'>
        <label htmlFor="username" className="pl-1 flex text-sm font-medium leading-6 text-gray-900 items-center">
            {title}
        </label>
        { rightText && 
          <label htmlFor="username" className="pl-1 flex text-sm font-medium leading-6 text-red-600 items-center mr-2">
              {rightText}
          </label>
        }
      </div>
        <div className="w-full flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300">
        <input
          type="text"
          name={name}
          id={name}
          value={typeof value === 'number' && !isNaN(value) ? value : (value || "")}
          onChange={handleInputChange}
          className={`${readonlyClass} ${customClass} w-full pl-2 block flex-1 border-0 py-1.5 pl-1 ${textClass} placeholder:text-gray-400 rounded-md sm:text-sm sm:leading-6`}
          readOnly={readonly}
          disabled={disable}
        />
        </div>
    </div>
  )
}

export default Input
